export enum Roles {
  "ITD_STAFF" = "itd-staff",
  "ITD_CUSTOMER" = "itd-customer",
  "ITD_CUSTOMER_WITH_ACCESS_TO_CHILD_ACCOUNTS" = "itd-customer-with-access-to-child-accounts",
  "ITD_ADMIN_FOR_SALES_ACCOUNTS" = "itd-admin-for-sales-accounts",
  "ITD_CUSTOMER_USER_ADMIN" = "itd-customer-user-admin",
  "ITD_SALES_PEOPLE_FOR_SALES_ACCOUNTS" = "itd-sales-people-for-sales-accounts",
}
